import React from 'react';
import {motion} from 'framer-motion';
//styles
import './Header.scss'

import {images} from '../../constants/';

//lottie animation
import LottieAnimation from "../../animations/Lottie";
import portfolio from '../../animations/portfolio.json';
//App wrap component
import {AppWrap} from "../../wrapper";

const scaleVariants = {
    whileInView: {
        scale: [0, 1],
        opacity: [0, 1],
        transition: {
            duration: 1,
            ease: 'easeInOut'
        }
    }
}

const Header = () => {


    return (
        <div className="app__header">
            <motion.div
                whileInView={{x: [-100, 0], opacity: [0, 1]}}
                transition={{duration: 1}}
                className="app__header-info"
            >
                <div className="app__header-badge">
                    <div className="badge-cmp app__flex">
                        <span>👋</span>
                        <div style={{marginLeft: 20}}>
                            <p className="p-text">Hello I am</p>
                            <h1 className="head-text">Mahamed</h1>
                        </div>
                    </div>

                    <div className="tag-cmp app__flex">
                        <p className="p-text">Front-end Developer</p>
                    </div>

                </div>
            </motion.div>

            <motion.div
                whileInView={{opacity: [0, 1]}}
                transition={{duration: 0.5, delayChildren: 0.5}}
                className="app__header-img"
            >

                <LottieAnimation
                    lotti={portfolio}

                />

                {/*<img src={images.profile} alt="profile"/>*/}
                <motion.img
                    whileInView={{scale: [0, 1]}}
                    transition={{duration: 1, ease: 'easeInOut'}}
                    className="overlay__circle"
                    src={images.circle}
                    alt="Profile_circle"
                />
            </motion.div>

            <motion.div
                variant={scaleVariants}
                whileInView={scaleVariants.whileInView}
                className="app__header-circles"
            >{[images.react, images.redux, images.typescript].map((circle, index) => (
                <div
                    className="circle-cmp app__flex"
                    key={index}
                >
                    <img src={circle} alt="circle"/>
                </div>
            ))}
            </motion.div>
        </div>
    )
}
export default AppWrap(Header, 'home');